import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

/**
 * 未触发条件单
 */
@Component({
})
export default class TradeSearch extends Vue {

  @Prop()
  public tableData;

  public tableTitle: IFixedTableTitle[] = [
    {
      text: '合约',
      width: '2rem',
      name: 'targetId',
    },
    {
      text: '开平',
      width: '1.5rem',
      name: 'offset',
    },
    {
      text: '成交价格',
      width: '2rem',
      name: 'price',
    },
    {
      text: '成交手数',
      width: '2rem',
      name: 'tradedVolume',
    },
    {
      text: '成交时间',
      width: '3rem',
      name: 'insertTime',
    },
    // {
    //   text: '成交编号',
    //   width: '2rem',
    //   name: 'tradeId',
    // },
    // {
    //   text: '报单编号',
    //   width: '2rem',
    //   name: 'orderId',
    // }
  ];
}



// WEBPACK FOOTER //
// ./src/views/TradeDetail/components/TradeSearch/TradeSearch.ts